<template>
  <div class="job-categories-list">
    <component
      v-for="category in categories"
      role="button"
      class="job-categories-list__item"
      :is="as_links && selected_category_alias !== category.alias ? 'a' : 'span'"
      :aria-label="category.title"
      :href="as_links && selected_category_alias !== category.alias ? category.link : null"
      :class="{active: selected_category_alias === category.alias}"
      @click="emitCategory($event, category)"
      :key="`job-categories-item_${category.id}`">
      {{category.title}}
    </component>
  </div>
</template>

<script>
export default {
  name: 'JobCategoriesList',
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    selected_category_alias: {
      type: String,
      default: ''
    },
    as_links: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitCategory(e, job_category) {
      if (!e.target.href) {
        e.preventDefault()
      }
      return this.$emit('selectedCategory', job_category)
    }
  }
}
</script>
